import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormPrice from '../general-input-form/FormPrice'
import FormDatePicker from '../general-input-form/FormDatePicker'

const AppForm = ({
  values,
  handleChange,
  errors,
  onDateChange,
  isEditPerPayroll,
  isEditBulkPayroll
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormPrice
          id='payroll_value'
          name='payroll_value'
          colSize='6'
          className='mb-3'
          inputLabel='Salary value (Nett Take Home Pay)'
          placeholder='Enter salary value...'
          value={values.payroll_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.payroll_value}
          invalid={errors.payroll_value}
        />
        <FormPrice
          id='payroll_tax_value'
          name='payroll_tax_value'
          colSize='6'
          className='mb-3'
          inputLabel='Tax'
          placeholder='Enter payroll tax'
          value={values.payroll_tax_value}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.payroll_tax_value}
          invalid={errors.payroll_tax_value}
        />
        <FormDatePicker 
          id='payroll_date'
          name='payroll_date'
          colSize='6'
          inputLabel={isEditPerPayroll ? `Payroll Date` : `Payroll Start Date`}
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.payroll_date}
          feedbackInvalid={errors.payroll_date}
          invalid={errors.payroll_date}
          minDate={isEditBulkPayroll ? values.first_last_payroll_date?.first_payroll_date : null}
          maxDate={isEditBulkPayroll ? values.first_last_payroll_date?.last_payroll_date : null}
          disabled={isEditPerPayroll ? true : false}
          cleaner={false}
        />
        <FormPrice 
          id='payroll_bpjs_kesehatan'
          name='payroll_bpjs_kesehatan'
          colSize='6'
          inputLabel='BPJS Kesehatan'
          className='mb-3'
          placeholder='Enter bpjs kesehatan...'
          value={values.payroll_bpjs_kesehatan}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.payroll_bpjs_kesehatan}
          invalid={errors.payroll_bpjs_kesehatan}
        />
        <FormPrice 
          id='payroll_bpjs_ketenagakerjaan'
          name='payroll_bpjs_ketenagakerjaan'
          colSize='6'
          inputLabel='BPJS Ketenagakerjaan'
          className='mb-3'
          placeholder='Enter bpjs ketenagakerjaan...'
          value={values.payroll_bpjs_ketenagakerjaan}
          handlePriceInput={handleChange}
          feedbackInvalid={errors.payroll_bpjs_ketenagakerjaan}
          invalid={errors.payroll_bpjs_ketenagakerjaan}
        />
      </CRow>
    </>
  )
}

export default AppForm